<template>
  <div>
    <movementmenuVue />

    <v-container fluid class="pa-6" tag="section">
      <v-row class="mb-4">
        <v-col cols="12">
          <div class="d-flex align-center justify-space-between flex-wrap">
            <div>
              <h2 class="text-h4 font-weight-bold primary--text">
                <v-icon large color="primary" class="mr-2"
                  >mdi-calendar-clock</v-icon
                >
                ปฏิทินการดำเนินการย้าย{{ label("ข้าราชการครู") }}
              </h2>
              <div class="subtitle-1 grey--text text--darken-1 mt-1">
                ติดตามกำหนดการและขั้นตอนการดำเนินงานประจำปี
              </div>
            </div>

            <div class="d-flex align-center mt-2 mt-md-0">
              <v-chip
                color="primary lighten-5"
                text-color="primary darken-2"
                class="mr-2"
                label
                large
              >
                <v-icon left>mdi-account-details</v-icon>
                สถานะ: <strong>{{ label("ข้าราชการครู") }}</strong>
              </v-chip>
              <v-btn
                color="success"
                rounded
                elevation="2"
                @click="exportSchedule"
              >
                <v-icon left>mdi-file-excel</v-icon> Export กำหนดการ
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-card elevation="2" class="rounded-xl overflow-hidden">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">mdi-timeline-text-outline</v-icon>
            ลำดับขั้นตอนการดำเนินงาน
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-0 pa-md-6 grey lighten-5">
          <v-timeline :dense="$vuetify.breakpoint.smAndDown" align-top>
            <v-timeline-item
              color="info"
              fill-dot
              large
              icon="mdi-calendar-range"
            >
              <v-card class="elevation-2 rounded-lg">
                <v-card-title class="info lighten-5 info--text text--darken-3">
                  <span class="text-h6 font-weight-bold"
                    >1. กำหนดการ{{ label("ข้าราชการครู") }}</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <div v-if="user.userauthority_govem != '1' && user.userauthority_govem != 1">
                    <Period />
                  </div>
                  <div v-if="user.userauthority_govem === '1' || user.userauthority_govem === 1">
                    <Period_govem />
                  </div>
                </v-card-text>
              </v-card>
            </v-timeline-item>

            <v-timeline-item
              color="primary"
              fill-dot
              large
              icon="mdi-book-open-page-variant"
            >
              <v-card class="elevation-2 rounded-lg">
                <v-card-title
                  class="primary lighten-5 primary--text text--darken-3"
                >
                  <span class="text-h6 font-weight-bold"
                    >2. วิทยาลัยแจ้งเงื่อนไขสาขาวิชา</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <periodCollege />
                </v-card-text>
              </v-card>
            </v-timeline-item>

            <v-timeline-item
              color="primary"
              fill-dot
              large
              icon="mdi-account-box-multiple"
            >
              <v-card class="elevation-2 rounded-lg">
                <v-card-title
                  class="primary lighten-5 primary--text text--darken-3"
                >
                  <span class="text-h6 font-weight-bold"
                    >3. รวบรวมคำร้องขอย้าย</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <periodCollegeRequest />
                </v-card-text>
              </v-card>
            </v-timeline-item>

            <v-timeline-item
              v-if="user.userauthority_govem != '1' && user.userauthority_govem != 1"
              color="info"
              fill-dot
              large
              icon="mdi-gavel"
            >
              <v-card class="elevation-2 rounded-lg">
                <v-card-title class="info lighten-5 info--text text--darken-3">
                  <span class="text-h6 font-weight-bold"
                    >4. สอจ. พิจารณาย้าย (ย้ายออก)</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <periodVecprovinces />
                </v-card-text>
              </v-card>
            </v-timeline-item>

            <v-timeline-item
              v-if="user.userauthority_govem != '1' && user.userauthority_govem != 1"
              color="info"
              fill-dot
              large
              icon="mdi-comment-processing"
            >
              <v-card class="elevation-2 rounded-lg">
                <v-card-title class="info lighten-5 info--text text--darken-3">
                  <span class="text-h6 font-weight-bold"
                    >5. วิทยาลัยปลายทาง (รับฟังความคิดเห็น)</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <periodCollegediscussTeach />
                </v-card-text>
              </v-card>
            </v-timeline-item>

            <v-timeline-item
              color="success"
              fill-dot
              large
              icon="mdi-file-document-check"
            >
              <v-card class="elevation-2 rounded-lg">
                <v-card-title
                  class="success lighten-5 success--text text--darken-3"
                >
                  <span class="text-h6 font-weight-bold"
                    >6. วิทยาลัยปลายทาง (รับรายงานตัว)</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <PeriodCollegeTeachReport />
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-container>

    <v-snackbar
      v-model="snackbar.show"
      :timeout="3000"
      :color="snackbar.color"
      top
      right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Period from "../../../components/admin/period.vue";
import periodCollege from "../../../components/admin/periodCollege.vue";
import periodCollegeRequest from "../../../components/admin/periodCollegeRequest.vue";
import periodVecprovinces from "../../../components/admin/periodVecprovinces.vue";
import periodCollegediscussTeach from "../../../components/admin/periodCollegediscussTeach.vue";
import PeriodCollegeTeachReport from "../../../components/admin/periodCollegeTeachReport.vue";
import movementmenuVue from "../../../components/admin/movementmenu.vue";
import Period_govem from "../../../components/admin/period_govem.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "HRvecTransferTeachers",
  components: {
    Period,
    periodCollege,
    periodCollegeRequest,
    periodVecprovinces,
    periodCollegediscussTeach,
    PeriodCollegeTeachReport,
    movementmenuVue,
    Period_govem
  },
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      user: {},
      snackbar: { show: false, text: "", color: "success" }
    };
  },
  async mounted() {
    await this.userQueryAll();
  },
  methods: {
    async userQueryAll() {
      try {
        let userSession = JSON.parse(localStorage.getItem("user")) || {};
        if (userSession.user_ID) {
          let result = await this.$http.post("user.php", {
            ApiKey: this.ApiKey,
            user_ID: userSession.user_ID
          });
          this.user = result.data;
        }
      } catch (e) {
        console.error("Error fetching user data", e);
      } finally {
        this.loading = false;
      }
    },

    label(text) {
      if (!this.user || !text) return text;
      return this.user.userauthority_govem === "1"
        ? text.replace(/ข้าราชการครู/g, "พนักงานราชการ")
        : text;
    },

    exportSchedule() {
      // Define the steps structure for export
      const isTeacher = this.user.userauthority_govem !== "1";
      const roleLabel = isTeacher ? "ข้าราชการครู" : "พนักงานราชการ";

      let steps = [
        {
          step: 1,
          action: `กำหนดการ${roleLabel}`,
          description: "กำหนดช่วงเวลาการดำเนินการ"
        },
        {
          step: 2,
          action: "วิทยาลัยแจ้งเงื่อนไขสาขาวิชา",
          description: "ระบุสาขาวิชาที่เปิดรับและอัตราว่าง"
        },
        {
          step: 3,
          action: `รวบรวมคำร้องขอย้าย${roleLabel}`,
          description: "ตรวจสอบและรวบรวมคำร้อง"
        }
      ];

      if (isTeacher) {
        steps.push({
          step: 4,
          action: `สอจ. พิจารณาย้าย${roleLabel} (ย้ายออก)`,
          description: "กลั่นกรองและอนุมัติการย้ายออก"
        });
        steps.push({
          step: 5,
          action: "วิทยาลัยปลายทาง (รับฟังความคิดเห็น)",
          description: "พิจารณาความเหมาะสม"
        });
      }

      steps.push({
        step: isTeacher ? 6 : 4,
        action: "วิทยาลัยปลายทาง (รับรายงานตัว)",
        description: "บันทึกผลการรายงานตัว"
      });

      // Create Excel
      const worksheet = XLSX.utils.json_to_sheet(steps);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Schedule");

      // Auto-width for better visibility (Approximate)
      const wscols = [{ wch: 10 }, { wch: 40 }, { wch: 40 }];
      worksheet["!cols"] = wscols;

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      });

      saveAs(data, `Transfer_Schedule_${roleLabel}.xlsx`);
      this.snackbar.text = "ดาวน์โหลดกำหนดการเรียบร้อยแล้ว";
      this.snackbar.show = true;
    }
  }
};
</script>

<style scoped>
/* Custom tweaks for timeline card content */
.v-timeline-item__body .v-card {
  border-radius: 12px;
}
</style>
